module.exports = __webpack_public_path__ + "img/m3_t2_en.34be33cd.svg";